// A provider can pick any brand accent colour; a pale one is unreadable as text on white (and a dark one on the
// dark theme). ensureContrast nudges a colour toward black or white until it reaches `min` contrast on `bg`.
const hexToRgb = (hex) => {
  const m = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec((hex || "").trim());
  if (!m) return null;
  let h = m[1];
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  return [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16));
};
const toHex = (rgb) => "#" + rgb.map((v) => Math.round(Math.max(0, Math.min(255, v))).toString(16).padStart(2, "0")).join("");
const lum = ([r, g, b]) => {
  const f = (v) => { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); };
  return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
};
export const contrastRatio = (a, b) => {
  const [l1, l2] = [lum(a), lum(b)].sort((x, y) => y - x);
  return (l1 + 0.05) / (l2 + 0.05);
};

export function ensureContrast(hex, bgHex, min = 4.5) {
  const fg = hexToRgb(hex), bg = hexToRgb(bgHex);
  if (!fg || !bg) return hex;
  if (contrastRatio(fg, bg) >= min) return hex;
  const target = lum(bg) > 0.5 ? [0, 0, 0] : [255, 255, 255];   // darken on light backgrounds, lighten on dark
  for (let t = 0.05; t <= 1.001; t += 0.05) {
    const mixed = fg.map((v, i) => v + (target[i] - v) * t);
    if (contrastRatio(mixed, bg) >= min) return toHex(mixed);
  }
  return toHex(target);
}
